/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompassDeviceAnalytics } from './CompassDeviceAnalytics';
import {
    CompassDeviceAnalyticsFromJSON,
    CompassDeviceAnalyticsFromJSONTyped,
    CompassDeviceAnalyticsToJSON,
    CompassDeviceAnalyticsToJSONTyped,
} from './CompassDeviceAnalytics';

/**
 * 
 * @export
 * @interface CompassAnalyticsResponse
 */
export interface CompassAnalyticsResponse {
    /**
     * 
     * @type {Array<CompassDeviceAnalytics>}
     * @memberof CompassAnalyticsResponse
     */
    one_month: Array<CompassDeviceAnalytics>;
    /**
     * 
     * @type {Array<CompassDeviceAnalytics>}
     * @memberof CompassAnalyticsResponse
     */
    six_months: Array<CompassDeviceAnalytics>;
}

/**
 * Check if a given object implements the CompassAnalyticsResponse interface.
 */
export function instanceOfCompassAnalyticsResponse(value: object): value is CompassAnalyticsResponse {
    if (!('one_month' in value) || value['one_month'] === undefined) return false;
    if (!('six_months' in value) || value['six_months'] === undefined) return false;
    return true;
}

export function CompassAnalyticsResponseFromJSON(json: any): CompassAnalyticsResponse {
    return CompassAnalyticsResponseFromJSONTyped(json, false);
}

export function CompassAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompassAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'one_month': ((json['oneMonth'] as Array<any>).map(CompassDeviceAnalyticsFromJSON)),
        'six_months': ((json['sixMonths'] as Array<any>).map(CompassDeviceAnalyticsFromJSON)),
    };
}

export function CompassAnalyticsResponseToJSON(json: any): CompassAnalyticsResponse {
    return CompassAnalyticsResponseToJSONTyped(json, false);
}

export function CompassAnalyticsResponseToJSONTyped(value?: CompassAnalyticsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oneMonth': ((value['one_month'] as Array<any>).map(CompassDeviceAnalyticsToJSON)),
        'sixMonths': ((value['six_months'] as Array<any>).map(CompassDeviceAnalyticsToJSON)),
    };
}

